import { pxToRem } from "../../../utils/pxToRem";

export const columnTitle = {
  fontWeight: 600,
  lineHeight: pxToRem(28),
  marginBottom: pxToRem(20),
};

export const columnLink = {
  fontSize: pxToRem(14),
  lineHeight: pxToRem(40),
};
